module.exports = __webpack_public_path__ + "static/media/subOutlook2.d93b624f.png";